const removeUnderscore = str => str.replace(/_/g, ' ')

export default removeUnderscore
